<template>
   <v-card
          class="pa-2"
          outlined
          tile
        >
         <p class='grey--text title'>Exposures:</p>
         
  <v-simple-table dense>
    <template v-slot:default>
      <thead>
        <tr>
          <th class="text-left">Name</th>
          <th class="text-left">use per week</th>
          <th class="text-left">Details</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in currentPatient.health.exposures" :key="item.name">
          <td>{{ item.name }}</td>
          <td>{{ item.usePerWeek }}</td>
          <td>{{ item.detail }}</td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
        </v-card>
</template>

<script>
export default {
  props : {
        currentPatient : Object
    }
}
</script>

<style>

</style>